/** @type {import('@nuxt/types').Middleware} */
const localeMiddleware = function({ route, app }) {
    const lang = String(route.query.lang);
    if (lang && lang !== app.i18n.locale && app.i18n.localeCodes.includes(lang)) {
        app.i18n.setLocale(lang);
    }
};

export default localeMiddleware;
